import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { UseProductGroup } from "./UseProductGroup";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu, rsParentChilds } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CustomPagination from "../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import SelectGroup from "../../ContentManagement/firstPage/HomeOffer/SelectGroup";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

function EditProductGroup(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [group, setGroup] = useState();
  const {
    getGroupByID,
    validate,
    updateGroup,
    addRelatedGroup,
    deleteRelatedGroup,
  } = UseProductGroup();
  const [state, setState] = useState({
    id: undefined,
    faName: undefined,
    enName: undefined,
    description: undefined,
    metaDescription: undefined,
  });
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [addGroup, setAddGroup] = useState(false);
  const [parentID, setParentID] = useRecoilState(rsParentChilds);
  const [stateAdd, setStateAdd] = useState({
    masterID: props.ClusterID,
    slaveID: "",
  });
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [name, setName] = useState("");
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.state && location.state.id) {
      setProgress(true);
      getGroupByID(location.state.id, (groupRes) => {
        setStateAdd({ ...stateAdd, masterID: groupRes.id });
        setState(groupRes);
      });
    }
  }, []);

  const [errorState, setErrorState] = useState({
    faName: false,
    enName: false,
  });

  const newFunc = () => {
    setParentID({
      id: null,
      name: undefined,
    });
    setAddGroup(true);
  };

  const columns = [
    {
      field: "id",
      width: 90,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "slaveID",
      width: 90,
      align: "center",
      headerName: "کد گروه",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "faName",
      width: 300,
      align: "center",
      headerName: "نام گروه",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 80,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.faName,
                id: cellValues.row.slaveID,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/productgroups" },
          { name: "ویرایش گروه محصول", url: "/productgroups/editproductgroup" },
        ],
      }}
    >
      {!group ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              sx={{ mt: 1, width: "100%" }}
              value={state.faName ? state.faName : ""}
              error={errorState.faName}
              label="نام فارسی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, faName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              value={state.enName ? state.enName : ""}
              error={errorState.enName}
              sx={{
                width: "100%",
                input: { direction: "rtl" },
              }}
              label="نام لاتین"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, enName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn="span 12">
            <Typography sx={{ mb: 1 }} variant="subtitle1" color="secondary">
              توضیحات :
            </Typography>
            {state.id != "" && (
              <CKEditor
                config={{
                  language: "fa",
                  link: {
                    decorators: {
                      addTargetToExternalLinks: {
                        mode: "automatic",
                        callback: (url) => /^(https?:)?\/\//.test(url),
                        attributes: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                    },
                  },
                }}
                editor={Editor}
                style={{ p: "100px", width: "100%" }}
                data={state.description ? state.description : ""}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  if (state.id) {
                    setState({
                      ...state,
                      description: data,
                    });
                  }
                }}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "350px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
              />
            )}
          </Box>
          <Box gridColumn="span 12">
            <Typography sx={{ mb: 1 }} variant="subtitle1" color="secondary">
              توضیحات متا :
            </Typography>
            <TextField
              fullWidth
              value={state.metaDescription ? state.metaDescription : ""}
              multiline
              maxRows={5}
              onChange={(evt) => {
                if (
                  evt.target.value.length < 151 ||
                  evt.target.value.length < state.metaDescription.length
                ) {
                  setState({ ...state, metaDescription: evt.target.value });
                  return;
                } else {
                  setState({
                    ...state,
                    metaDescription: state.metaDescription,
                  });
                  enqueueSnackbar("بیشتر از مقدار مجاز (150 کاراکتر)", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
              }}
              size="small"
              variant="outlined"
            />
          </Box>
          {state.parentGroup && (
            <Box gridColumn="span 12">
              <Typography variant="subtitle1" color="secondary">
                گروه های مرتبط
              </Typography>
              {state?.groups ? (
                <Box sx={{ height: "25rem", mt: 1 }}>
                  <DataGrid
                    localeText={
                      faIR.components.MuiDataGrid.defaultProps.localeText
                    }
                    columns={columns}
                    rows={state.relatedGroups ? state.relatedGroups : []}
                    page={pageState.page - 1}
                    pageSize={20}
                    Pagination
                    onPageChange={(newPage) => {
                      setPageState((old) => ({
                        ...pageState,
                        page: newPage + 1,
                      }));
                    }}
                    rowCount={
                      state.relatedGroups && state.relatedGroups.length
                        ? state.relatedGroups.length
                        : 1
                    }
                    disableColumnMenu
                    hideFooterSelectedRowCount
                    components={{
                      Pagination: CustomPagination,
                    }}
                    componentsProps={{
                      pagination: {
                        // nofab: true,
                        newFunc: newFunc,
                        noPageCount: true,
                        rowCount:
                          state.relatedGroups && state.relatedGroups.length
                            ? state.relatedGroups.length
                            : "",
                      },
                    }}
                    initialState={{
                      sorting: {
                        sortModel: [
                          {
                            field: "id",
                            sort: "asc",
                          },
                        ],
                      },
                    }}
                  />
                </Box>
              ) : (
                <ProgressCom></ProgressCom>
              )}
            </Box>
          )}
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateGroup(state, () => {
                    navigate("/productgroups", {
                      state: location.state,
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/productgroups", {
                  state: location.state,
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"گروه"}
        callback={() => {
          setProgress(true);
          let model = {
            slaveID: deleteState.id,
            masterID: state.id,
          };
          deleteRelatedGroup(model, () => {
            getGroupByID(location.state.id, (groupRes) => {
              setState(groupRes);
            });
          });
        }}
      ></DeleteRow>
      <Dialog
        PaperProps={
          {
            // elevation: 1,
          }
        }
        sx={{ zIndex: 200 }}
        fullWidth
        maxWidth={addGroup ? "lg" : "sm"}
        open={addGroup}
        onClose={() => setAddGroup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SelectGroup
              slaveID
              setName={setName}
              selectedGroupID={stateAdd.slaveID ? stateAdd.slaveID : undefined}
              setter={setStateAdd}
              lvl1State={stateAdd}
            ></SelectGroup>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (!stateAdd.slaveID) {
                    enqueueSnackbar("گروه را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  setProgress(true);
                  addRelatedGroup(stateAdd, () => {
                    getGroupByID(location.state.id, (groupRes) => {
                      setState(groupRes);
                    });
                    setAddGroup(false);
                    setParentID({
                      id: null,
                      name: undefined,
                    });
                    setStateAdd({ ...stateAdd, slaveID: undefined });
                  });
                }}
              >
                ثبت
              </Button>
              <Button
                onClick={() => setAddGroup(false)}
                color="secondary"
                variant="outlined"
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Detail>
  );
}

export default EditProductGroup;
